import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, CreditCard, Clock } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-6 pb-10 md:pt-12 md:pb-20 px-4 overflow-hidden bg-cf-darker" data-id="element-226">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-cf-gold to-transparent pointer-events-none" data-id="element-227" />

      <div className="max-w-3xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-228">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center gap-4 md:gap-6 w-full" data-id="element-229">
          <div className="inline-block bg-cf-card border border-cf-gold/30 text-cf-gold px-3 py-1 md:px-4 md:py-1.5 rounded-full text-[10px] md:text-sm font-bold tracking-widest uppercase" data-id="element-230">
            Sistema completo para instructores
          </div>

          <h1 className="font-bebas text-5xl md:text-7xl lg:text-8xl leading-[0.9] tracking-tight text-white" data-id="element-231">
            TODO TU AÑO DE <br data-id="element-232" />
            <span className="text-cf-gold" data-id="element-233">CROSSFIT RESUELTO</span>
          </h1>

          {/* Mockup at 70% size, between title and subtitle */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative w-[70%] my-2 md:my-4" data-id="element-234">
            <div className="absolute inset-0 bg-cf-gold/20 blur-[100px] rounded-full" data-id="element-235" />
            <img src="https://cdn.magicpatterns.com/uploads/2yq5T4GTcHY6UphwqXhisU/Mockup_crossfit_resuelto.png" alt="Megapack Crossfit Resuelto Mockup" className="w-full h-auto relative z-10 drop-shadow-2xl" data-id="element-236" />
          </motion.div>

          

          <p className="text-sm md:text-lg text-gray-400 max-w-2xl" data-id="element-237">
            Tu año completo de crossfit listo: programación, técnica olímpica,
            escalado, fuerza, evaluación y gestión del box. Sin improvisar. Sin
            el domingo de pánico antes de la semana.
          </p>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-sm font-semibold text-gray-200 mt-2" data-id="element-238">
            <div className="flex items-center gap-2 bg-cf-card px-3 py-2 rounded border border-white/10" data-id="element-239">
              <CheckCircle2 className="w-5 h-5 text-cf-gold" data-id="element-240" />
              <span data-id="element-241">PDF digital</span>
            </div>
            <div className="flex items-center gap-2 bg-cf-card px-3 py-2 rounded border border-white/10" data-id="element-242">
              <Clock className="w-5 h-5 text-cf-gold" data-id="element-243" />
              <span data-id="element-244">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-2 bg-cf-card px-3 py-2 rounded border border-white/10" data-id="element-245">
              <CheckCircle2 className="w-5 h-5 text-cf-gold" data-id="element-246" />
              <span data-id="element-247">Todos los niveles</span>
            </div>
          </div>

          <div className="mt-2 md:mt-6 flex flex-col gap-3 md:gap-4 w-full max-w-xl" data-id="element-248">
            <a href="#pricing" className="bg-cf-gold hover:bg-cf-goldHover text-black font-bebas text-xl md:text-3xl py-3 md:py-4 px-4 md:px-8 rounded text-center transition-colors uppercase tracking-wide flex items-center justify-center gap-3" data-id="element-249">
              💥 QUIERO MI CROSSFIT RESUELTO AHORA
            </a>

            <div className="flex flex-wrap justify-center gap-4 text-xs md:text-sm text-gray-400 font-medium" data-id="element-250">
              <span className="flex items-center gap-1" data-id="element-251">
                <ShieldCheck className="w-4 h-4" data-id="element-252" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-253">
                <ShieldCheck className="w-4 h-4" data-id="element-254" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-255">
                <CreditCard className="w-4 h-4" data-id="element-256" /> Mercado Pago | Tarjeta
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}